import { render, staticRenderFns } from "./productlineOfDepartment2.vue?vue&type=template&id=a8cbad20&scoped=true&"
import script from "./productlineOfDepartment2.vue?vue&type=script&lang=js&"
export * from "./productlineOfDepartment2.vue?vue&type=script&lang=js&"
import style0 from "./productlineOfDepartment2.vue?vue&type=style&index=0&id=a8cbad20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cbad20",
  null
  
)

export default component.exports